import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, ToastController, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { EmailValidator } from '../../validators/email';
import { DateTimeAdapter } from 'ng-pick-datetime';
import * as moment from 'moment';

interface myInterface2 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  name: string;
  sessionDate: Date;
  tasks: string[];
}

@IonicPage()
@Component({
  selector: 'page-user-update-admin',
  templateUrl: 'user-update-admin.html',
})
export class UserUpdateAdminPage {
  public max = new Date();
  data: any;
  myForm: FormGroup;
  inputFile: any[] = [""];
  files: any[] = [];
  arrayFiles: any[] = [];
  loading: Loading;
  idItem: string = '';

  sessionDoc: AngularFirestoreDocument<myInterface2>;
  session: myInterface2;
  coaches: any[];

  constructor(dateTimeAdapter: DateTimeAdapter<any>, public asf: AngularFirestore, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public viewCtrl: ViewController) {
    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish
    this.data = this.navParams.get("item");
    this.idItem = this.data.id;
    this.myForm = this.formBuilder.group({
      // coach: [this.data && this.data.coach ? this.data.coach : ''],
      type: [this.data && this.data.type ? this.data.type : 0, [Validators.required]],
      name: [this.data && this.data.name ? this.data.name : '', [Validators.required]],
      lastName: [this.data && this.data.lastName ? this.data.lastName : '', [Validators.required]],
      sex: [this.data && this.data.sex ? this.data.sex : ''],
      email2: [this.data && this.data.email2 ? this.data.email2 : '', [EmailValidator.isValid]],
      dob: [this.data && this.data.dob ? moment(this.data.dob).format("YYYY-MM-DD") : ''],
      company: [this.data && this.data.company ? this.data.company : 'Gepp'],
      ocupation: [this.data && this.data.ocupation ? this.data.ocupation : 'director'],
      phone: [this.data && this.data.phone ? this.data.phone : ''],
    });
    this.asf.collection("Users").ref.where("type", "==", 3).orderBy("uppercaseName", "asc").get().then(collection => {
      this.coaches = collection.docs.map(document => {
        const data = document.data();
        const id = document.id;
        return { id, ...data }
      });
    }).catch(error => {
      ////console.error(error);
    });
  }

  guardar(item: any) {
    this.viewCtrl.dismiss({ type: 'updated', data: item });
  }

  async updateSession(): Promise<any> {
    if (this.myForm.value.type == 2) {
      return await this.asf.collection('Sessions').ref.where('idAlumno', '==', this.idItem).where("sessionDate", ">=", new Date()).get().then(async (collection) => {
        if (!collection.empty) {
          var batch = this.asf.firestore.batch();
          let arreglo = [];
          //          let arreglo2 = [];
          collection.forEach(ele => {
            arreglo.push(ele.id);
            batch.update(ele.ref, { idCoach: this.myForm.get('coach').value });
          });
          for (let i = 0; i < arreglo.length; i++) {
            await this.asf.collection('Tasks').ref.where("idSesion", "==", arreglo[i]).get().then(collect => {
              if (!collect.empty) {
                collect.forEach(e => {
                  batch.update(e.ref, { idCoach: this.myForm.get('coach').value });
                });
              } else {
                return;
              }
            }).catch(error => {
              ////console.error(error);
              return;
            });
          }
          return await batch.commit().then(() => {
            return "success";
          });
        } else {
          return;
        }
      });
    } else {
      return;
    }
  }

  SetForm(typeUser) {
    // if (typeUser == 2) {
    //   this.myForm.controls['coach'].validator = Validators.required;
    // } else {
    //   this.myForm.controls['coach'].clearValidators();
    // }
  }

  remove_duplicates(arr) {
    var obj = {};
    var ret_arr = [];
    for (var i = 0; i < arr.length; i++) {
      obj[arr[i]] = true;
    }
    for (var key in obj) {
      ret_arr.push(key);
    }
    return ret_arr;
  }

  ionViewDidLoad() { }

  onSubmit() {
    this.presentLoadingCustom();
    if (this.myForm.value.dob) {
      this.myForm.value.dob = moment(this.myForm.value.dob).format("YYYY-MM-DD");
    }
    let update = {
      company: this.myForm.value.company,
      dob: this.myForm.value.dob,
      email2: this.myForm.value.email2,
      name: this.myForm.value.name,
      lastName: this.myForm.value.lastName,
      uppercaseName: String(this.myForm.value.lastName + " " + this.myForm.value.name).toLocaleUpperCase(),
      ocupation: this.myForm.value.ocupation,
      phone: this.myForm.value.phone,
      sex: this.myForm.value.sex,
      //coach: this.myForm.value.coach,
      type: Number(this.myForm.value.type)
    }
    this.asf.doc('Users/' + this.data.id).update(update).then(res => {
      this.updateSession().then(() => {
        this.asf.doc('Users/' + this.data.id).ref.get().then(data => {
          const ret = data.data();
          ret['id'] = data.id;
          this.loading.dismiss();
          this.presentToast("Usuario editado correctamente");
          this.guardar(ret);
        });
      }).catch(error => {
        this.loading.dismiss();
        ////console.error(error);
        this.presentToast("¡Ha ocurrido un error!");
      });
    }).catch(error => {
      this.loading.dismiss();
      ////console.error(error);
      this.presentToast("¡Ha ocurrido un error!");
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  cancel() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-update-admin/user-update-admin.ts